import moment from 'moment'
import BaseEntity from './BaseEntity'

const Props = {
  token: undefined,
  expiresTime: undefined,
}

class AccessToken extends BaseEntity {
  get isExpired() {
    return moment().isAfter(moment(this.expiresTime))
  }
}

export default function createAccessToken(params) {
  const attr = Object.assign({}, Props, params)
  return Object.freeze(new AccessToken(attr))
}
